import { z } from 'zod'

/**
 * Calendly Docs: https://calendly.stoplight.io/docs/api-docs/69c58da556b61-webhook-payload
 *
 * There are other fields that are not being used, therefore not included in the schema.
 */
export const calendlyEventSchema = z.object({
  created_at: z.coerce.date(),
  created_by: z.url(),
  event: z.enum(['invitee.created', 'invitee.canceled', 'invitee_no_show.created']),
  payload: z.object({
    created_at: z.coerce.date(),
    email: z.email(),
    event: z.url(),
    name: z.string(),
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    rescheduled: z.boolean(),
    reschedule_url: z.string(),
    timezone: z.string().nullable(),
    cancel_url: z.string(),
    text_reminder_number: z.string().nullable().optional(),
    questions_and_answers: z.array(
      z.object({
        question: z.string(),
        answer: z.string(),
      })
    ),
    tracking: z.object({
      utm_campaign: z.string().nullable(),
      utm_source: z.string().nullable(),
      utm_medium: z.string().nullable(),
      utm_content: z.string().nullable(),
      utm_term: z.string().nullable(),
      salesforce_uuid: z.string().nullable(),
    }),
    scheduled_event: z.object({
      name: z.string().nullable(),
      event_memberships: z.array(
        z.object({
          user_email: z.string(),
        })
      ),
      start_time: z.coerce.date(),
      end_time: z.coerce.date(),
      location: z.object({
        type: z.string(),
        join_url: z.string().nullish(),
      }),
      event_type: z.url(),
    }),
  }),
})

export const createCalendlyEventSchema = z.object({
  event: calendlyEventSchema.shape.event,
  payload: calendlyEventSchema.shape.payload.pick({
    email: true,
  }),
})

export type CreateCalendlyEvent = z.infer<typeof createCalendlyEventSchema>
export type CalendlyEvent = z.infer<typeof calendlyEventSchema>
